module.exports = __webpack_public_path__ + "img/guitar.be5030ca.webp";